import React, { Component } from 'react'

class Empty extends Component {
    render() {
        return <div>Empty</div>
    }
}

export default Empty
